<template>
    <div class="payout-wrapper">
        <div v-if="mode === 'artistEvent' && paidData.payout_info" class="payout-text">
            <p class="payout-title">Payout Summary</p>
            <div class="payout-container">
                <p class="payout-price">You Get: ${{ paidData.payout_info.artist_get }}</p>
            </div>
            <div class="payout-info">
                <p class="clears-payout">{{ payoutLanguage }}</p>
                <p class="clears-payout">Clears {{ artistPayoutClears(paidData.clears) }}</p>
            </div>
            <p class="payout-description">
                You’re all set! Payouts made through Hedlyner are automatically charged 24
                hours prior to the start of the event, and automatically clear 48 hours after
                the start of the event.
            </p>
        </div>
        <div class="artist-list" v-if="!mode">
            <p class="payout-title">Payout Summary</p>
            <p class="venue-payout-text">
                You’re all set! Payouts made through Hedlyner are automatically charged 24
                hours prior to the start of the event, and automatically clear 48 hours after
                the start of the event.
            </p>
            <div class="header-table d-flex justify-content-between">
                <p style="flex: 0 1 278px">Artist</p>
                <p v-if="width > 1000" style="flex: 0 1 84px">You Pay</p>
                <p v-if="width > 1000" style="flex: 0 1 84px">Hedlyner Fees</p>
                <p v-if="width > 1000" style="flex: 0 1 84px">Artist Payout</p>
                <p style="flex: 0 1 200px">Payment Method</p>
                <p v-if="width > 1000" style="flex: 0 1 200px">Clears</p>
                <p v-if="width > 1000">Actions</p>
            </div>
            <hr style="background: #8b8b8b; height: 1.5px; margin: 0" />
            <div v-for="(artist, index) in artists" :key="index">
                <PayLaterModal
                    :show.sync="payLater.show"
                    :artist-name="payLater.artistName"
                    :artist-id="payLater.artistId"
                    :bid-artist-id="payLater.bidArtistId"
                    :bid-id="payLater.bidId"
                    :venue-fee="payLater.venueFee"
                />
                <div class="table-content">
                    <div v-if="width > 1000" class="desktop-version d-flex">
                        <div
                            @click="goToArtist(artist.slug)"
                            role="button"
                            class="d-flex artist-content"
                        >
                            <img :src="artist.avatar" />
                            <p>{{ artist.artist }}</p>
                        </div>
                        <p class="payout-text-table">${{ artist.payout }}</p>
                        <p class="payout-text-table">${{ artist.hedlyner_fee }}</p>
                        <p class="payout-text-table">${{ artist.artist_gets }}</p>
                        <p class="payment-method">
                            {{ artist.payment_method }}
                            <span v-if="artist.payment_method !== 'Cash'" class="card-content"
                                >via Hedlyner</span
                            >
                        </p>
                        <p class="clears">
                            {{ payoutClearsDate(artist.clears) }}
                        </p>
                        <button @click="() => payArtistLater(artist)" class="pay">
                            Add Pay
                        </button>
                    </div>
                    <div v-else class="mobile-version">
                        <div class="mobile-first-row">
                            <div class="d-flex artist-content">
                                <img :src="artist.avatar" />
                                <div class="artist-info">
                                    <p>{{ artist.artist }}</p>
                                    <p class="venue-pays">Payout ${{ artist.payout }}</p>
                                </div>
                            </div>
                            <p class="payment-method">
                                {{ artist.payment_method }}
                                <span
                                    v-if="artist.payment_method !== 'Cash'"
                                    class="card-content"
                                    >via Hedlyner</span
                                >
                            </p>
                        </div>
                        <div class="mobile-second-row">
                            <div class="payout-language">
                                <p class="payout-info-text">
                                    Hedlyner Fees: ${{
                                        parseFloat(artist.venue_fee).toFixed(2)
                                    }},
                                </p>
                                <p class="payout-info-text">
                                    Artist Gets: ${{ artist.payout }}
                                </p>
                            </div>
                            <div class="clear-and-pay">
                                <p class="payout-info-text">
                                    Clears {{ payoutClearsDate(artist.clears) }}
                                </p>
                                <button @click="() => payArtistLater(artist)" class="pay">
                                    Add Pay
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <hr style="background: #8b8b8b; height: 1.5px; margin: 0" />
            </div>
        </div>
        <div>
            <p v-if="!mode" class="contact-text">
                No-shows or other problems?
                <a class="contact-link" href="mailto:support@hedlyner.com">
                    Contact venue support for help.
                </a>
            </p>
            <p v-if="mode === 'artistEvent'" class="contact-text">
                Last minute cancellations or other problems?
                <a class="contact-link" href="mailto:support@hedlyner.com"
                    >Contact artist support for help.
                </a>
            </p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import checkScreen from '../../../../mixins/check-screen'
    import PayLaterModal from './PayLaterModal.vue'

    export default {
        name: 'PayoutSummary',
        components: {
            PayLaterModal
        },
        mixins: [checkScreen],
        props: {
            eventId: {
                type: Number
            },
            mode: {
                type: String
            },
            counterOfferData: {
                type: Object
            },
            artistId: {
                type: Number
            }
        },
        data: () => ({
            artists: [],
            bookingId: '',
            paidData: {},
            artistFeedback: [],
            venueFeedback: [],
            payLater: {
                show: false,
                artistName: '',
                artistId: null,
                bidId: null,
                venueFee: null
            }
        }),
        computed: {
            artistPayoutClears: () => (clears) => {
                const clearsArr = clears.split(', ')
                const clearDate = clearsArr[0]

                return moment(clearDate).format('MMM Do, YYYY')
            },
            hedlynerCommission: (self) =>
                parseFloat(self.paidData.artist_fee * self.paidData.payout_info.venue_pays),
            payoutLanguage: (self) => {
                const artistFee = parseFloat(self.paidData.payout_info.venue_pays)

                return `Artist Fee: $${artistFee.toFixed(
                    2
                )}, Hedlyner Commission: $${self.hedlynerCommission.toFixed(2)}`
            },
            paymentMethod: () => (payment) => `${payment.slice()}`,
            venuePays: () => (artist) =>
                parseFloat(artist.payout + artist.venue_fee).toFixed(2)
        },
        methods: {
            payArtistLater(artist) {
                this.payLater.show = true
                this.payLater.artistName = artist.artist
                this.payLater.bidArtistId = artist.bid_artist_id
                this.payLater.bidId = artist.bid_id
                this.payLater.artistId = artist.artist_id
                this.payLater.venueFee = parseFloat(artist.venue_fee)
            },
            goToArtist(slug) {
                if (!slug) return
                window.open('/artists/' + slug, '_blank')
            },
            getIcon() {
                return '/images/'
            },
            async getPayoutSummary() {
                const response = await axios.get(
                    '/api/events/manage/' + this.eventId + '/payout-summary'
                )
                this.artists = response.data.data
            },
            async getPayoutArtist() {
                const response = await axios.get(
                    `/api/booking-manager/artist/${this.eventId}/payout/${this.artistId}`
                )
                this.artistFeedback.push(response.data.data)
                this.paidData = response.data.data
                this.bookingId = this.artistFeedback[0].booking_id
                this.$emit('update:bookingId', this.bookingId)
                let venueFeedbackData = {}
                if (!this.venueFeedback.length) {
                    venueFeedbackData = {
                        venue_name: this.artistFeedback[0].venue_info.name,
                        venue_picture: this.artistFeedback[0].venue_info.avatar
                    }
                } else {
                    venueFeedbackData = this.venueFeedback[0]
                }
                this.$emit('update:venueFeedbackData', venueFeedbackData)
            },
            async getVenueReview() {
                const response = await axios.get('/api/get/venue/' + this.eventId)
                this.venueFeedback = response.data.data
            },
            payoutClearsDate(date) {
                if (date === 'n/a') return date

                return moment(date).format('MMM Do, YYYY')
            }
        },
        async created() {
            if (this.mode === 'artistEvent') {
                await this.getVenueReview()
                await this.getPayoutArtist()
            } else {
                await this.getPayoutSummary()
            }
            this.$emit('update:artists', this.artists)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .payout-container {
        display: flex;
        align-items: baseline;
        gap: 28px;
        margin-top: 50px;
    }
    .payout-info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 24px;
    }
    .clears-payout {
        text-wrap: nowrap;
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .paid-payout {
        color: #d47ebf;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .payout-price {
        text-wrap: nowrap;
        color: #d47ebf;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .card-content {
        color: #d188bf;
        font-family: 'Instrument Sans';
        font-size: 10px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin-bottom: 5px;
    }
    .contact-text {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .contact-link {
        color: inherit;
    }
    .artist-content img {
        max-width: 40px;
        max-height: 40px;
        border-radius: 5px;
    }
    .artist-content p {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 242px;
    }
    .artist-content {
        align-items: center;
        gap: 12px;
        flex: 0 1 278px;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        max-width: 464px;
    }
    .payout-text-table {
        flex: 0 1 84px;
        max-width: 464px;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .clears {
        flex: 0 1 200px;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .payment-method {
        max-width: 464px;
        flex: 0 1 200px;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .table-content {
        padding: 12px 0;
    }
    .desktop-version {
        justify-content: space-between;
        align-items: center;
    }
    .mobile-version {
        display: flex;
        flex-direction: column;
    }
    .mobile-first-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mobile-second-row {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .payout-language {
        display: flex;
        flex-direction: column;
    }
    .venue-pays {
        color: #acacac !important;
        font-family: 'Instrument Sans';
        font-size: 12px !important;
        font-style: normal;
        font-weight: 650 !important;
        line-height: 135% !important;
        letter-spacing: 0.12px;
    }
    .payout-info-text {
        color: #646464;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin-bottom: 0px;
    }
    .payout-text {
        max-width: 60%;
    }
    .artist-list {
    }
    .payout-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: 1050px;
        padding: 20px;
        background: #262626;
        border-radius: 15px;
        width: 100%;
        height: 100%;
        margin-bottom: 25px;
    }
    .payout-title {
        color: #dedede;
        font-size: 26px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .venue-payout-text {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        max-width: 724px;
        margin-bottom: 32px;
    }
    .payout-description {
        color: #8b8b8b;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .header-table p {
        text-wrap: nowrap;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin: 0;
        max-width: 464px;
    }
    .header-table {
        padding-bottom: 12px;
    }
    .clear-and-pay {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: flex-end;
        justify-content: center;
    }
    .pay {
        border: 1px solid #cdeb09;
        border-radius: 120px;
        color: #cdeb09;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        padding: 5px 10px;
        font-family: Instrument Sans;
        background: none;
    }
    @media (max-width: 1000px) {
        .pay {
            width: 100%;
        }
        .clears-payout {
            text-wrap: wrap;
        }
        .payout-price {
            text-wrap: wrap;
        }
        .payout-info {
            flex-direction: column;
            width: 100%;
            align-items: flex-start;
        }
        .payout-wrapper {
            background: transparent;
        }
        .payout-wrapper {
            padding: 16px;
        }
        .payout-text-table {
            flex: 0 1 84px;
            max-width: none;
        }
        .payment-method {
            flex: 0 1 200px;
            max-width: none;
        }
        .artist-content {
            flex: 0 1 278px;
            width: 33%;
            max-width: none;
        }
        .artist-content p {
            max-width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        .payout-text {
            max-width: 100%;
        }
        .header-table p {
            max-width: none;
        }
    }
</style>
